import { PropsWithChildren, useState } from "react";
import { createPortal } from "react-dom";
import { Box, Typography } from "@mui/material";

// Portal based iframe preview window
const NewsletterPreview = ({ children }: PropsWithChildren<unknown>) => {
  // Callback ref
  const [iframeRef, setIframeRef] = useState<HTMLIFrameElement | null>(null);
  const mountNode = iframeRef?.contentWindow?.document?.body;

  return (
    <Box
      sx={{
        border: (theme) => `1px solid ${theme.palette.divider}`,
        borderRadius: 3,
        backgroundColor: "background.paper",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          px: 2,
          py: 1.5,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography sx={{ fontSize: "0.9375rem", fontWeight: 600 }}>
          Vorschau
        </Typography>
      </Box>

      {/* The preview renders the real email HTML, so it stays on a white
          sheet regardless of the app theme - that is what recipients see. */}
      <Box
        component="iframe"
        ref={setIframeRef}
        title="Newsletter-Vorschau"
        sx={{
          display: "block",
          width: "100%",
          height: "80vh",
          border: 0,
          backgroundColor: "#FFFFFF",
        }}
      >
        {/* If iframe is mounted, create portal */}
        {mountNode && createPortal(children, mountNode)}
      </Box>
    </Box>
  );
};

export default NewsletterPreview;
